/**
 * Build a https://wa.me/<digits> link from a phone number as typed by a shop
 * owner ("0812-3456-7890", "+62 812 3456 7890", ...). Indonesian numbers
 * starting with 0 are converted to the 62 country code.
 * Returns null when there is no usable number, so the UI can hide itself.
 */
export function whatsappDigits(raw) {
  if (!raw) return '';
  let digits = String(raw).replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  else if (digits.startsWith('0')) digits = `62${digits.slice(1)}`;
  return digits.length >= 8 ? digits : '';
}

export function whatsappUrl(raw, text) {
  const digits = whatsappDigits(raw);
  if (!digits) return null;
  return `https://wa.me/${digits}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}
